import LangIcon from './LangIcon'
import Router from 'next/router';
// import LoginFloat from './LoginFloat'
import SuspendFloat from './SuspendFloat'
import { useEffect, useState } from 'react';
import Supportbtn from './Supportbtn';
import UserAvatar from '@/frontend/components/qecomps/UserAvatar'
import Link from 'next/link';
import Searcher from './Searcher';
import ReplacePro from '@/frontend/components/qecomps/ReplacePro'
import dynamic from 'next/dynamic';
import Bold from '@/frontend/components/qecomps/Bold';
import { setCookie } from 'cookies-next';
import Path from './Path';
import GoToTop from './GoToTop';
import { SSRGlobal } from '../qecomps/Context';
import Img from '../qecomps/Img.tsx';
import Copy from '../qecomps/Copy.ts';
import CircleBow from './CircleBow.tsx';

const DonationFloat = dynamic(() => import("./DonationFloat.tsx").then(x => x.default), { ssr: false })

export default (props) => {

  let z = SSRGlobal()

  var [form, setForm] = useState<any>();
  // useEffect(() => {
  //   // global.setScroller("wind")
  // })

  let paths = Path((arr, text: string) => {
    if (text == "device") return false;
    if (text.toLowerCase() == "e") return false;
    if (text.toLowerCase() == "t") return false;
    if (text == "sarkhattiagahv1") { return arr.length > 3 ? () => Router.back() : global.reloadsession }
    if (text == "netexpv1") { return arr.length > 3 ? () => Router.back() : global.reloadsession }
    if (text == "chatcontent" && arr.length == 3) return true; //return "/" + temparr[1] + "/chats"
    if (text == "chatcontent" && arr.length != 3) return "/chats"
    return true;
  }, props.pathtranslate);


  if (props.loginshow) { form = "login" }
  useEffect(() => {
    if (z.user.loggedin) {
      if (document.getElementById("loginform"))
        document.getElementById("loginform").style.display = "none";
    }
  })

  if (z.user?.email) {
    setCookie("uid", z.user.uid, { sameSite: "lax" })
  }

  return <>

    {/* {form == "login" ? <LoginFloat onclose={() => { props.onloginclosed?.(); props.loginshow ? null : setForm(null) }} /> : null} */}
    {z.user.suspend ? <SuspendFloat onclose={() => { props.onloginclosed?.(); props.loginshow ? null : setForm(null) }} /> : null}

    {/* {form == "cart" ? <CartFloat onclose={()=>setForm(null)}/> : null} */}
    <f-cc style={{
      width: "100vw",
      position: props.float ? "fixed" : "relative", top: 0, zIndex: 200
    }}>
      <f-csb className={props.nobg ? "" : z.styles.bg0} style={{
        padding: '5px 4px',
        width: "100%",
        maxWidth: props.full ? "" : "1200px",
        marginBottom: '0px',
        height: 55, direction: "ltr"
      }}>

        <Searcher defaultValue={props.defaultValue} />
      </f-csb>


    </f-cc>



    {z.user.path.includes("/t/") || props.nopaths ? null : <f-c className={z.styles.bg0} style={{
      position: "relative", padding: '4px 4px', width: "100%", maxWidth: "1200px",
      height: 35, fontSize: 12,
    }} >
      <sp-3 />
      <Img src={global.cdn("/files/route1.svg")} style={{ height: 20, width: 20, transform: z.lang.dir == "rtl" ? "scaleX(-1)" : null }} /><sp-2 />
      {paths}
    </f-c>}


    {(!z.user.loggedin || props.stopnotifications) ? null :
      <>
        {(z.user.mfaenabled || true) ? null : <f-c className={z.styles.bg0} style={{
          position: "relative", padding: '4px 4px', width: "100%", maxWidth: "1200px",
          height: 35, fontSize: 12,
        }} >
          <sp-3 />
          <Img src={global.cdn("/files/ga.svg")} style={{ height: 20, width: 20 }} /><sp-2 />
          {z.lang.plzenablemfa}<sp-3 /><Link href={z.root + "/account"}>{z.lang.gotoprofile}</Link>
        </f-c>}

        {z.user.cmntcount > 0 ? <><f-c className={z.styles.bg0}
          style={{
            position: "relative",
            padding: '4px 4px', width: "100%", maxWidth: "1200px",
            height: 35, fontSize: 12, cursor: "pointer",
          }}>
          <sp-3 />
          {/* <Img src={global.cdn("/files/comment.svg")} style={{ height: 20, width: 20 }} /> */}
          <icon class='w-[20px] h-[20px] icon-[fluent-color--comment-multiple-16]' />
          <sp-2 />
          <Link href={z.root + "/admin/comments"} style={{ padding: "0 5px" }}><span>
            {
              ReplacePro(z.lang.newcmnt, "XX", <Bold key={"header_cmnt"}
                style={{ color: "green", padding: "0 5px", textDecoration: "underline" }}>
                {z.user.cmntcount.toLocaleString(z.lang.region)}</Bold>)
            }</span></Link>
        </f-c></> : null}


        {z.user.unreadchats && Object.keys(z.user.unreadchats).length > 0 ? <>
          <f-c className={z.styles.bg0}
            style={{
              position: "relative",
              padding: '4px 4px', width: "100%", maxWidth: "1200px",
              height: 35, fontSize: 12, cursor: "pointer",
            }}>
            <sp-3 />
            <Img src={global.cdn("/files/message.svg")} style={{ height: 23, width: 25 }} /><sp-2 />
            <Link href={z.root + "/chats"}><span>{ReplacePro(z.lang.newmsg, "XX", <Bold key={"unreadchats_num"} style={{ color: "green", padding: "0 5px", textDecoration: "underline" }}>
              {Object.keys(z.user.unreadchats).length.toLocaleString(z.lang.region)}</Bold>)}</span></Link><sp-3 />
          </f-c></> : null}

        {z.user.donate ? <f-csb
          className={z.styles.bg0}
          id="donatenotif"
          class={z.styles.hover} style={{
            transition: "all 6s",
            padding: '4px 4px', width: "100%", maxWidth: "1200px",
            height: 35, fontSize: 12, cursor: "pointer",
          }}>
          <f-c>
            <sp-3 />
            <Img src={form == "donatecancel" ? global.cdn("/files/sad3.svg") : global.cdn("/files/heart.svg")}
              style={{ height: form == "donatecancel" ? 25 : 20, width: form == "donatecancel" ? 25 : 23 }} /><sp-2 />
            {z.user.donate != "done" ? <h4>{z.lang.wecoldonate}
              <a style={{ color: "green", padding: "0 10px" }} onClick={() => {
                cache("page", { page: "donationopen" })
                setForm("donation")
              }}>{z.lang.idonate}</a></h4> : null}
            {z.user.donate == "done" ? <h4>{z.lang.tnx}</h4> : null}

            <sp-3 />
          </f-c>
          <Img className={z.styles.hover} src={global.cdn("/files/close.svg")} style={{ height: 15, width: 15, margin: "0 8px 0 8px" }}
            on={async () => {
              if (z.user.donate != "done") {
                cache("page", { page: "donationcancel" })
                setForm("donatecancel");
              }
              let json = await API["financial/donate"]({
                cancel: true
              })
              setTimeout(() => { z.user.donate = false; setForm(null); }, 5000)
              document.getElementById("donatenotif").style.opacity = "0";
            }} />
        </f-csb> : null}
        {/* <f-c style={{ width: "100%", maxWidth: "1200px", borderTop: "solid 0.5px gray", height: 0 }} /> */}

      </>}

    {form == "donation" ? <DonationFloat onclose={() => setForm(null)} /> : null}
    {props.nosupport ? null : <Supportbtn loginrequired={() => { setForm("login") }} />}
    {props.gototop ? <GoToTop /> : null}
  </>

}